import {Permission, Preference} from 'app/components/role-form/role.model';
import {Entity} from '../pages/product/product.model';

export interface Project {
    name: string;
    id: number;
}

export interface Configuration {
    // projectStatuses: string[];
    // projectAreas: string[];
    // projectDisplay: string[];
    // hideEstimation: string;
    // daysToRegisterAfterMonth: number;
    // hideImportsExports: boolean;
    // requiredAttributes: any;
    key: string;
    label: string;
    value: string;
    type: string;
}

export class Instrument {
    id: number;
    description: string;
    serialNumber: string;
    model: InstrumentModel;
    // brand: string;
    clientCode: string;
    familyId?: number;
    modelId?: number;

    constructor(props?: any) {
        props = props || {};
        this.id = props.id || 0;
        this.description = props.description || '';
        this.serialNumber = props.serialNumber || '';
        this.model = props.model ? new InstrumentModel(props.model) : null;
        // this.brand = props.brand || '';
        this.clientCode = props.clientCode || '';
        this.familyId = props.familyId || 0;
        this.modelId = props.modelId || 0;

    }


}

// export interface ModelProxy {
//     id: number;
//     name: string;
//     brand: string;
// }


export class InstrumentModel extends Entity {

    id: number;
    name: string;
    magnitudes?: Magnitude[];
    family: InstrumentType;
    brand: InstrumentBrand;


    constructor(entity?: any ) {
        super();
        entity = entity || {};
        this.id = entity.id ;
        this.name = entity.name || '';
        this.enabled = entity.enabled !== undefined ? entity.enabled : true;
        this.magnitudes = entity.magnitudes || [];
        this.family = entity.family ? new InstrumentType(entity.family) : entity.family;
        this.brand = entity.brand ? new InstrumentBrand(entity.brand) : entity.brand;
    }

}

export class InstrumentBrand {

    name: string;
    id: number;

    constructor(entity?: any ) {
        entity = entity || {};
        this.id = entity.id || 0;
        this.name = entity.name || '';
    }

}

export class StandardValue {

    id: number;
    indexName: string;
    name: string;
    familyId: number;
    magnitudeName: string;
    totalUncertainty: number;
    maxRange: number;
    unit: string;

    constructor(entity?: any ) {
        entity = entity || {};
        this.id = entity.id || 0;
        this.indexName = entity.indexName || '';
        this.name = entity.name || '';
        this.familyId = entity.familyId || 0;
        this.magnitudeName = entity.magnitudeName || '';
        this.totalUncertainty = entity.totalUncertainty || 0;
        this.maxRange = entity.maxRange || 0;
        this.unit = entity.unit || '';
    }
}

// public class ICC {
//
//     private Long id;
//     private String name;
//     private String description;
//     private String dataFormat;
//     private LocalDate updateDate;
//     private Integer version;
//     private String fileName;
//     private String filePath;
// }


export class ICC extends Entity {
    description?: string;
    dataFormat?: string;
    updateDate?: Date;
    version?: number;
    fileName?: string;
    filePath?: string;
    posibleMagnitudes?: string;
    hasCalibrator?: boolean;
    iccType?: string;
    aiDescription?: string;
    calibrators?: string;
    procedure?: string;


    constructor(entity?: any) {
        super();
        entity = entity || {};
        this.id = entity.id || 0;
        this.name = entity.name || '';
        this.description = entity.description || '';
        this.dataFormat = entity.dataFormat || '';
        this.updateDate = entity.updateDate;
        this.version = entity.version || 0;
        this.fileName = entity.fileName || '';
        this.filePath = entity.filePath || '';
        this.posibleMagnitudes = entity.posibleMagnitudes || '';
        this.hasCalibrator = entity.hasCalibrator || false;
        this.iccType = entity.iccType || '';
        this.aiDescription = entity.aiDescription || '';
        this.calibrators = entity.calibrators || '';
        this.procedure = entity.procedure || '';
    }
}

export class MeasurePoint {

    id: number;
    unit?: string;
    range?: number;
    resolution?: number;
    percentageOfReading?: number;
    percentageOfFullScale?: number;
    digits?: number;
    standard?: StandardValue;

    constructor(entity?: any) {
        entity = entity || {};
        this.id = entity.id || 0;
        this.unit = entity.unit || '';
        this.range = entity.range || 0;
        this.resolution = entity.resolution || 0;
        this.percentageOfReading = entity.percentageOfReading || 0;
        this.percentageOfFullScale = entity.percentageOfFullScale || 0;
        this.digits = entity.digits || 0;
        this.standard = entity.standard ? new StandardValue(entity.standard) : null;
    }

}

export class Magnitude {

    id: number;
    name: string;
    label: string;
    description?: string;
    measurePoints?: MeasurePoint[];
    maxRange?: number;
    minRange?: number;
    weightOrder?: number;

    constructor(entity?: any) {
        entity = entity || {};
        this.id = entity.id || 0;
        this.name = entity.name || '';
        this.label = entity.label || '';
        this.maxRange = entity.maxRange;
        this.minRange = entity.minRange;
        this.description = entity.description || '';
        this.measurePoints = entity.measurePoints || [];
        this.weightOrder = entity.weightOrder || 0;
    }
}


export class InstrumentType extends Entity{

    description: string;
    icc: ICC;
    calibrationPrice: number;
    batteryPrice: number;
    casePrice: number;
    fusePrice: number;
    cablesPrice: number;

    constructor(entity?: any) {
        super();
        entity = entity || {};
        this.id = entity.id || 0;
        this.name = entity.name || '';
        this.enabled = entity.enabled !== undefined ? entity.enabled : true;
        this.description = entity.description || '';
        this.calibrationPrice = entity.calibrationPrice || 0;
        this.batteryPrice = entity.batteryPrice || 0;
        this.casePrice = entity.casePrice || 0;
        this.fusePrice = entity.fusePrice || 0;
        this.cablesPrice = entity.cablesPrice || 0;
        this.icc = entity.icc ? new ICC(entity.icc) : null;
    }

}



export class Visibility {
    seguimiento: boolean;
    startDate: boolean;
    endDate: boolean;
    projectType: boolean;
    areas: boolean;
    createdBy: boolean;
    createdDate: boolean;
    hhReport: boolean;
    projectReport: boolean;
    billing: boolean;
    responsable: boolean;
    showRegisterAfterMonth: boolean;
    hideEstimationRole: boolean;
    showImportMenu: boolean;
    calibrationModuleOn: boolean;
    language: string;
    displayedColumns: string[];


    constructor(entity?: any) {
        entity = entity || {};
        this.seguimiento = entity.seguimiento !== undefined ? entity.seguimiento : true;
        this.startDate = entity.startDate !== undefined ? entity.startDate : true;
        this.endDate = entity.endDate !== undefined ? entity.endDate : true;
        this.projectType = entity.projectType !== undefined ? entity.projectType : true;
        this.areas = entity.areas !== undefined ? entity.areas : true;
        this.createdBy = entity.createdBy !== undefined ? entity.createdBy : true;
        this.createdDate = entity.createdDate !== undefined ? entity.createdDate : true;
        this.hhReport = entity.hhReport !== undefined ? entity.hhReport : true;
        this.projectReport = entity.projectReport !== undefined ? entity.projectReport : true;
        this.billing = entity.billing !== undefined ? entity.billing : true;
        this.responsable = entity.responsable !== undefined ? entity.responsable : true;
        this.showRegisterAfterMonth = entity.showRegisterAfterMonth !== undefined ? entity.showRegisterAfterMonth : false;
        this.hideEstimationRole = entity.hideEstimationRole !== undefined ? entity.hideEstimationRole : true;
        this.showImportMenu = entity.showImportMenu !== undefined ? entity.showImportMenu : false;
        this.calibrationModuleOn = entity.calibrationModuleOn !== undefined ? entity.calibrationModuleOn : false;
        this.language = entity.language !== undefined ? entity.language : 'es';
        this.displayedColumns = entity.displayedColumns !== undefined ? entity.displayedColumns : [];
    }
}


export interface Usuario {
    userId: number;
    name: string;
    login: string;
    password: string;
    configurations?: Configuration[];
    permissions: Permission[];
    preferences: Preference[];
}

export interface Quote {
    id: number;
    client: Entity;
    lines: QuoteLine[];
    changeStatusDate?: string; // ISO string, puede cambiarse a Date si se prefiere
    contacto?: string;
    email?: string;
    date: string; // ISO string, puede cambiarse a Date si se prefiere
    reference?: string;
    status?: string;
    type?: string;
    currency?: string;
    totalPrice?: number;
    version?: string; // una letra del abecedario, por ejemplo 'A', 'B', etc.
    notes?: string;
}

export interface QuoteLine {
    id: number;
    quantity: number;
    price: number;
    quote?: Quote;
    family: InstrumentType; // O InstrumentFamily si existe
    clientReference?: string;
    date?: string; // ISO string, puede cambiarse a Date si se prefiere
    adjustmentFactor?: number;
    type?: string;
}
